import React, { useState } from 'react';
import './ListingPage.css';

const STORAGE_KEY = 'listingbyadmin:pin';
const ADMIN_PIN = '777';

export function hasSavedAdminPin() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === ADMIN_PIN;
  } catch {
    return false;
  }
}

function saveAdminPin() {
  try {
    window.localStorage.setItem(STORAGE_KEY, ADMIN_PIN);
  } catch {
    /* storage disabled — unlock for this visit only */
  }
}

/** Blocks the admin listing wizard until PIN 777 is entered, then remembers it. */
const AdminPinGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(hasSavedAdminPin);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  const submit = (event) => {
    event.preventDefault();
    if (pin.trim() !== ADMIN_PIN) {
      setError('Incorrect PIN');
      setPin('');
      return;
    }
    saveAdminPin();
    setError('');
    setUnlocked(true);
  };

  if (unlocked) return children;

  return (
    <div className="listing-shell admin-pin-shell">
      <form className="admin-pin-card" onSubmit={submit}>
        <p className="admin-pin-kicker">TabTrips admin</p>
        <h1>Enter PIN</h1>
        <p className="admin-pin-copy">This listing page is for staff creating a host account.</p>
        <label htmlFor="admin-listing-pin">PIN</label>
        <input
          id="admin-listing-pin"
          type="password"
          inputMode="numeric"
          autoComplete="off"
          autoFocus
          value={pin}
          maxLength={8}
          onChange={(e) => {
            setPin(e.target.value.replace(/\D/g, '').slice(0, 8));
            if (error) setError('');
          }}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error ? 'admin-pin-error' : undefined}
        />
        {error && (
          <p id="admin-pin-error" className="admin-pin-error" role="alert">
            {error}
          </p>
        )}
        <button type="submit" disabled={!pin}>
          Continue
        </button>
      </form>
    </div>
  );
};

export default AdminPinGate;
